import { createContext, useState } from "react";

export const RelationContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [relations, setRelations] = useState([]);

    // Make the context object:
    const relationContext = {
        relations,
        setRelations,
    };

    // pass the value in provider and return
    return <RelationContext.Provider value={relationContext}>{children}</RelationContext.Provider>;
};

export const { Consumer } = RelationContext;
